<template>
  <div style="width: 100%; height: 100%">
    <a-row class="header">
      <a-col :span="24">
        <a-dropdown :trigger="['click']">
          <span
            style="color: #333333;"
          >
            {{ selectFrameWork.name }} <a-icon type="down" />
          </span>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="framework in frameworkList"
              :key="framework.id"
              @click="changeFrameWork(framework)"
            >
              <span>{{ framework.name }}</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-col>
    </a-row>
    <!-- <a-row>
      <div class="body__index_div">
        <div class="tags-class">
          <div
            @click="changeTag(tag)"
            :class="itemIndex == tag.id ? 'selectClassceshi' : 'tag-class'"
            v-for="tag in tags"
            :key="tag.id"
          >
            {{ tag.name }}
          </div>
        </div>
      </div>
    </a-row> -->
    <codemirror
      style="width: 100%; margin-bottom: 30px;height:100%;"
      v-model="code"
      :options="cmOption"
      class="code-mirror"
    ></codemirror>
  </div>
</template>
<script>
import { codemirror } from "vue-codemirror";
import bus from '@/utils/Bus';
import componentApi from "@/request/api-manager/component.js";
export default {
  props:{
    page: {
      type: Object,
      default: (() => {})
    }
  },
  data() {
    return {
      // pageId: null,
      // projectId: null,
      frameworkList: [
        // {
        //   id: 1,
        //   name: "uniapp代码",
        // },
        // {
        //   id: 2,
        //   name: "h5代码",
        // },
        // {
        //   id: 3,
        //   name: "taro代码",
        // },
        {
          id: 4,
          name: "vue代码",
        },
      ],
      code: "",
      selectFrameWork: {
        id: 4,
        name: "vue代码",
      },
      tags: [
        {
          id: 1,
          name: "index.vue",
        },
        {
          id: 2,
          name: "index.css",
        },
      ],
      itemIndex: 1,
      cmOption: {
        tabSize: 2, // tab
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: {
          // 模式, 可查看 codemirror/mode 中的所有模式
          name: "javascript",
          json: true,
        },
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false,
        },
        readOnly:true,
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: "sublime",
        matchBrackets: true,
        showCursorWhenSelecting: true,
        theme: "base16-light", // 主题
        extraKeys: { Ctrl: "autocomplete" }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
      },
      selectTag: { content: "" },
    };
  },
  mounted(){
    
  },
  components: {
    codemirror,
  },
  methods: {
    getPageCode(){
      if(!this.page.projectId || !this.page.id)
        return
      componentApi.getPageCode({
        pageId: this.page.id,
        projectId: this.page.projectId
      }).then(res => {
        if(!res.result)
          return
        this.code = res.result
      })
    },
    changeFrameWork(framework) {
      this.selectFrameWork = framework;
    },
    changeTag(tag) {
      this.itemIndex = tag.id;
    },
  },
};
</script>
<style scoped>
@import "./index.css";
</style>